import { combineReducers } from 'redux';
import userDataReducer from "./reducers/user-reducer";

const allReducers = combineReducers({
    userData: userDataReducer
});

export type RootState = ReturnType<typeof allReducers>
export default allReducers;